import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

export const Route = createFileRoute("/_lp/lp/business-plan")({
  // Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
  beforeLoad: assertDraftRouteVisible,
  head: () =>
    seo({
      title: "Business Plan Writing Service",
      description: "Investor and lender-grade business plans, delivered fast.",
      path: "/lp/business-plan",
      noindex: true,
    }),
  component: Page,
});

function Page() {
  return <PagePlaceholder title={"Business plan writing"} intro={"[SUPPLY: landing page copy]"} />;
}
